'use strict'
/**
 * Archivo con metodo para setear al modelo las variables que vengan por URL.
 *
 * @author Andres Correa
 * @since 25/08/2020 10:20 AM
 * @version 1.0.0
 */

const validarQueryParamsMixin = {
  methods: {
    /**
     * Metodo para validar los parametros por url
     *
     * @author Andres Correa
     * @since  25/08/2020 10:18 AM
     * @version 1.0.0
     */
    $_validateQueryParamsMixin_indivual (data, query, valida) {
      if (this.$route.query[data]) {
        this.modelo[query] = this.$route.query[data]
        if (this.modelo[query] && valida) {
          this.disabled[data] = true
        }
        return true
      }
      return false
    }
  }
}

export default validarQueryParamsMixin
